import { render } from "./PayoutRulesAgreementPopup.vue?vue&type=template&id=2cfe92ea&scoped=true&ts=true"
import script from "./PayoutRulesAgreementPopup.vue?vue&type=script&lang=ts"
export * from "./PayoutRulesAgreementPopup.vue?vue&type=script&lang=ts"

import "./PayoutRulesAgreementPopup.vue?vue&type=style&index=0&id=2cfe92ea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cfe92ea"]])

export default __exports__